export function organizacionesHelper (organizaciones) 
{
    let orgDataTable = {
        organizacionEps: [],
        organizacionSfps: []
    }
    organizaciones.map(organizacion => {
        let tmpData = {}
        if(organizacion.organizacionUsuario.organizacionEps){
            tmpData['codOrganizacion'] = organizacion.organizacionUsuario.organizacionEps.codOrganizacion ;
            tmpData['numRuc'] = organizacion.organizacionUsuario.organizacionEps.numRuc;
            tmpData['nomRazonSocial']= organizacion.organizacionUsuario.organizacionEps.nomRazonSocial;
            tmpData['codOrganizacionUsuario']=organizacion.organizacionUsuario.codOrganizacionUsuario;
            orgDataTable['organizacionEps'][orgDataTable['organizacionEps'].length]=tmpData;
        }
        if(organizacion.organizacionUsuario.organizacionSfps){
            tmpData['codOrganizacion']= organizacion.organizacionUsuario.organizacionSfps.codOrganizacion;
            tmpData['numRuc'] = organizacion.organizacionUsuario.organizacionSfps.numRuc;
            tmpData['nomRazonSocial']= organizacion.organizacionUsuario.organizacionSfps.nomRazonSocial;
            tmpData['codOrganizacionUsuario']=organizacion.organizacionUsuario.codOrganizacionUsuario;
            orgDataTable['organizacionSfps'][orgDataTable['organizacionSfps'].length] = tmpData;
        } 
    });
    return orgDataTable;   
}